/**
 * Where checkout sends the customer back to, and which dashboard banner greets them:
 *
 * - `plan`      → `?plan_success={scope}`
 * - `scheduled` → `?plan_success={scope}&scheduled={date}` — a future-dated payment is a
 *                 one-installment plan, so it shares the plan banner with different copy.
 * - `immediate` → `?payment_success={scope}`
 *
 * `scope` names the cases the return covers: a case id holds that one card pending while
 * the poll runs, ACCOUNT_SCOPE holds every open card. Centralised because the dashboard
 * treats any non-`case_` value as account-wide — a surface passing an account id instead
 * would work, and the drift would never surface.
 *
 * The server appends the `session_id` the dashboard polls.
 */

export const ACCOUNT_SCOPE = 'account';

type PaymentReturn =
  | { flow: 'plan'; scope: string }
  | { flow: 'scheduled'; scope: string; date: string }
  | { flow: 'immediate'; scope: string; saved?: number };

export function paymentReturnUrl(options: PaymentReturn): string {
  const params = new URLSearchParams();

  if (options.flow === 'immediate') {
    params.set('payment_success', options.scope);
    if (options.saved != null && options.saved > 0) params.set('saved', options.saved.toFixed(2));
  } else {
    params.set('plan_success', options.scope);
    if (options.flow === 'scheduled') params.set('scheduled', options.date);
  }

  return `${window.location.origin}/dashboard?${params}`;
}
